module.exports = __webpack_public_path__ + "img/icon-mytarget-logo.c6ab456d.svg";